import {createMultiPathSVG} from './TEMPLATE'

// phosphor: chat-circle-dots
export const MessagePlus_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM84,116a12,12,0,1,0,12,12A12,12,0,0,0,84,116Zm88,0a12,12,0,1,0,12,12A12,12,0,0,0,172,116Zm60,12A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-16,0A88,88,0,1,0,51.81,172.06a8,8,0,0,1,.66,6.54L40,216,77.4,203.53a7.85,7.85,0,0,1,2.53-.42,8,8,0,0,1,4,1.08A88,88,0,0,0,216,128Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: chat-circle-fill (fill weight)
export const Message_Stroke1_Corner0_Rounded_Filled = createMultiPathSVG({
  paths: [
    'M232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: chat-circle
export const Message_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: chat-circle-fill (fill weight)
export const Message_Stroke2_Corner0_Rounded_Filled = createMultiPathSVG({
  paths: [
    'M232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Z',
  ],
  viewBox: '0 0 256 256',
})
